export default __webpack_public_path__ + "static/media/R_P_S.17ca068f.png";